import {useTranslation} from 'react-i18next'
import {EliminarConMotivoDialog} from '@/components/eliminar-con-motivo-dialog'
import {useMotivoError} from '@/hooks/common/use-motivo-error'
import {useDeleteEvaluacion, type BateriaEvaluacionEstado} from '@/hooks/bateria/use-bateria'
import {translateApiError} from '@/lib/errors'

const dateFormat = new Intl.DateTimeFormat('es-CO', {year: 'numeric', month: 'short', day: 'numeric'})

/** Una evaluación `entregada` no se elimina (Res. 2764/2022) y el llamador no monta este diálogo para
 * ella. Escaneos e informe no se borran: quedan bajo custodia con la traza. */
export function EliminarEvaluacionDialog({
  businessId,
  evaluacionId,
  fechaInicio,
  psicologoName,
  estado,
  personasConPaquete,
  open,
  onOpenChange,
  onDeleted,
}: {
  businessId: string
  evaluacionId: string
  fechaInicio: string
  psicologoName: string
  estado: BateriaEvaluacionEstado
  personasConPaquete: number
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted?: () => void
}) {
  const {t} = useTranslation()
  const deleteEvaluacion = useDeleteEvaluacion(businessId)
  const {error, setError, clear} = useMotivoError()

  const personas =
    personasConPaquete > 0
      ? t('admin.bateria.lifecycle.eliminarPersonasCount', {count: personasConPaquete})
      : t('admin.bateria.lifecycle.eliminarPersonasNinguna')

  return (
    <EliminarConMotivoDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('admin.bateria.lifecycle.eliminarTitle')}
      description={t('admin.bateria.lifecycle.eliminarDesc', {
        fecha: dateFormat.format(new Date(fechaInicio)),
        psicologo: psicologoName,
        estado: t(`admin.bateria.evaluacionEstado.${estado}`),
        personas,
      })}
      motivoLabel={t('admin.bateria.lifecycle.eliminarMotivoLabel')}
      motivoPlaceholder={t('admin.bateria.lifecycle.eliminarMotivoPlaceholder')}
      confirmLabel={t('admin.bateria.lifecycle.eliminarConfirm')}
      testIdPrefix="eliminar-evaluacion"
      pending={deleteEvaluacion.isPending}
      error={error}
      onReset={() => {
        clear()
        deleteEvaluacion.reset()
      }}
      onConfirm={(motivo) =>
        deleteEvaluacion.mutate(
          {evaluacionId, motivo},
          {
            onSuccess: () => {
              onDeleted?.()
              onOpenChange(false)
            },
            onError: (err) => setError(translateApiError(err)),
          }
        )
      }
    />
  )
}
